module.exports = __webpack_public_path__ + "static/media/Camaron.368f1f10.svg";